import React from 'react';
import ReactDOM from 'react-dom';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
// import DatePicker from 'react-date-picker';
// import DatePicker from 'react-datepicker';
import { Calendar } from 'react-date-range';
import { toast } from 'react-toastify';

// Parse typed PYE text ("5/31", "05/31", "5-31") into { mm, dd }, or null if it isn't a real month/day
export const parsePye = (text, year = 2023) => {
    const match = /^\s*(\d{1,2})\s*[/-]\s*(\d{1,2})\s*$/.exec(text ?? "");
    if (!match) return null;

    const mm = parseInt(match[1]);
    const dd = parseInt(match[2]);
    if (mm < 1 || mm > 12 || dd < 1 || dd > new Date(year, mm, 0).getDate()) return null;

    return { mm, dd };
}

export default class PyeCalendarSelector extends React.Component {
    constructor(props) {
        super(props);
       
        this.selectorRef = React.createRef(null);
        this.calendarRef = React.createRef(null);
     }
    state = {
        showSelector: false,
        endDd: 0,
        endMm: 0,
        endYy: this.props.endYy ?? 2023,
        minDate : new Date(2023, 1, 1),
        maxDate : new Date(2023, 1 + 10 , 0),
        startDate: new Date(),
        dateShow: new Date(2023, 11, 31),
        typedInValue: this.savedValue()
    }

    componentDidMount = () =>{
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    
    componentWillUnmount = () =>{
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    
    componentDidUpdate = (prev) => {
        if (this.props.endMm !== prev.endMm || this.props.endDd !== prev.endDd) {
            // Keep what the user is typing if it already matches the new value (e.g. "05/3" -> 5/3)
            const typed = parsePye(this.state.typedInValue, this.state.endYy);
            if (typed?.mm !== this.props.endMm || typed?.dd !== this.props.endDd)
                this.setState({ typedInValue: this.savedValue() });
        }
    }

    // Method (not a class field) so the state initializer above can call it
    savedValue() {
        return (this.props.endMm && this.props.endDd) ? `${this.props.endMm}/${this.props.endDd}` : "";
    }

    // Commit typed text to the parent as soon as it's a valid month/day
    handleTyped = async (text) => {
        this.setState({ typedInValue: text });

        const pye = parsePye(text, this.state.endYy);
        if (!pye || (pye.mm === this.props.endMm && pye.dd === this.props.endDd)) return;

        // Awaited so the parent's endMm update lands before endDd (editPlanField spreads this.state)
        await this.props.updateMm("endMm", pye.mm)
        await this.props.updateDd("endDd", pye.dd)

        this.props.onChange(true)
    }

    // Remember the value from before this edit, so invalid input can put it back
    handleFocus = () => {
        this.focusedValue = { mm: this.props.endMm, dd: this.props.endDd };
    }

    // On blur, never leave text in the box (or on the plan) that the user didn't finish typing
    handleBlur = async (e) => {
        const pye = parsePye(this.state.typedInValue, this.state.endYy);
        if (pye?.mm === this.props.endMm && pye?.dd === this.props.endDd) return;

        // No error if the user left the box to pick a date from the calendar instead
        const toCalendar = this.calendarRef.current?.contains(e?.relatedTarget);
        if (this.state.typedInValue.trim() !== "" && !toCalendar)
            toast.error("Please enter a valid date as MM/DD or select a date from the calendar");

        // Typing "2/30" commits 2/3 on the way, so restore the value from before the edit
        const before = this.focusedValue;
        if (before && (before.mm !== this.props.endMm || before.dd !== this.props.endDd)) {
            await this.props.updateMm("endMm", before.mm)
            await this.props.updateDd("endDd", before.dd)
        }

        this.setState({ typedInValue: this.savedValue() });
    }

    handleClickOutside = (event) => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
            this.setState({ showSelector: false });
        }


    }
    handleClickInside = (event) => {
        this.setState({ showSelector: !this.state.showSelector })
    }
    render = () => {
        return (<>
            <div className='tpa-plan-editor-calendar' style={(this.props?.style?.width ? {width: this.props.style.width} : {})}>
                <input 
                        type={"text"}
                        placeholder='MM/DD'
                        value={this.state.typedInValue}
                        id="pyeDate"
                        name="pyeDate"
                        onChange={e => this.handleTyped(e.target.value)}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                    />
                <div
                    className="plan-editor-plan-date-container"
                    onClick={(e) => {this.state.showSelector === false ? this.handleClickInside(e) : this.handleClickOutside(e);}}
                    ref={this.selectorRef}
                    
                >
                    <input
                        className="config-date-input"
                        type={"text"}
                        onChange={e => this.handleTyped(e.target.value)}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.target.blur();
                                this.setState({showSelector: false})
                            }
                        }}
                        value={this.state.typedInValue}   
                    />
                    
                    <div className="config-plan-date-icon" />
                    {this.state.showSelector ? <div
                        className="config-date-selector"
                        ref={this.calendarRef}
                        onClick={(e) => e.stopPropagation()}
                        style={{...(this.props?.style?.right ? {right: this.props.style.right} : {})}}
                    >
                        <Calendar
                            showMonthAndYearPickers={true}
                            date={new Date(this.state.endYy, this.props.endMm-1, this.props.endDd)}
                            months={1}
                            // showMonthArrow = {true}
                            direction="horizontal"
                            editableDateInputs={true}
                            onChange={async(value) => {
                                this.props.onChange(true)

                                await this.props.updateMm("endMm", parseInt(value.toLocaleDateString('en-US', {month: "numeric"})))
                                await this.props.updateDd("endDd", parseInt(value.toLocaleDateString('en-US', {day: "numeric"})))

                                if (this.props.updateYy) {
                                    // update year value
                                    this.props.updateYy("endYy", parseInt(value.toLocaleDateString('en-US', {
                                        year: "numeric"
                                    })));
                                }


                                this.setState({
                                    endYy : parseInt(value.toLocaleDateString('en-US', {
                                        year: "numeric"
                                    })),
                                    dateShow: value, 
                                    showSelector: false,
                                    typedInValue: `${value.getMonth() + 1}/${value.getDate()}`
                                });
                            }}
                        />
                    </div> : ""}
                </div>
            </div>
        </>)
    }
}